module.exports = __webpack_public_path__ + "img/logitembus_logo_2.df5feaf5.jpg";